import { Component, Input, OnInit } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { BaseControlComponent } from './base-control.component';

@Component({
    selector: 'app-toggle-control',
    template: `
    <div class="app-pr1 app-pb1" [formGroup]="formGroup">
      <mat-slide-toggle [formControlName]="formControlName" autocomplete="off"
        ><span
        >{{ label | translation: translationRequest }} {{ isRequired ? '*' : '' }}</span
        ></mat-slide-toggle
        >
        @if (hintLabel) {
          <div class="checkbox-hint">{{ hintLabel | translation: translationRequest }}</div>
        }
        <div>
          @if (formControl.invalid && formControl.touched) {
            <mat-error
              class="checkbox-error"
              >{{ errorMessage | translation: translationRequest }}</mat-error
              >
            }
          </div>
        </div>
    `,
    styles: [
        `
      .checkbox-hint {
        font-size: 12px;
        margin-left: 44px;
      }
      .checkbox-error {
        margin-left: 44px;
      }
      .label {
        padding-left: 8px;
      }
      :host .mat-mdc-slide-toggle {
        --mat-slide-toggle-selected-handle-horizontal-margin: 0 -2px;
        --mat-slide-toggle-selected-with-icon-handle-horizontal-margin: 0 -4px;
        --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0 -2px;
        --mat-slide-toggle-unselected-focus-track-color: var(--sed-warm-white-color) !important;
        --mat-slide-toggle-unselected-hover-track-color: var(--sed-warm-white-color) !important;
        --mat-slide-toggle-unselected-pressed-track-color: var(--sed-warm-white-color) !important;
      }
    `,
    ],
    standalone: false
})
export class ToggleControlComponent
  extends BaseControlComponent
  implements OnInit
{
  @Input()
  labelClass: string;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  _labelClass: string;

  ngOnInit(): void {
    this._labelClass = `label ${this.labelClass}`;
  }
}
